"use strict";
/*jshint esversion: 11 */

export function formatAttributeFromApi(attribute) {
  return attribute?.replace(/\s?\(.*?\)/g, ""); // Remove parentheses and everything in between
}

export function cleanPhoneNumber(number) {
  return number?.replace(/\D/g, ""); // remove any non digit characters
}

export function formatedLongEmail(email, maxChar) {
  if (email.length > maxChar) {
    return email.replace('@', '@<br />');
  }

  return email;
}

export function formatPhoneNumber(number = "") {
  let cleaned = number.replace(/\D/g, "");
  let regex = /^(1|)?(\d{3})(\d{3})(\d{4})$/;
  let match = regex.exec(cleaned);
  if (match) {
    let intlCode = (match[1] ? '+1 ' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}

export function getTodayLongDate(langCode) {
  const today = new Date();
  const day = today.getDate();
  const month = today.toLocaleString(langCode === 'en' ? 'en-CA' : 'fr-CA', { month: 'long' });
  const year = today.getFullYear();

  return langCode === 'en' ? `${month} ${day}, ${year}` : `${day} ${month} ${year}`;
}


//Gestion cookie
export const COOKIE_LOGGED_IN_NAME = "EspaceMembreLoggedIn";
export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
